import { Box, Button, CardMedia, Dialog, IconButton, TableCell, TableRow, Theme, Typography } from "@mui/material";
import { OrderListObj, PaymentApprovalListObj } from "../../redux-store/types/orderManagement";
import dayjs from "../../utils/dayjs";
import { ColorMap } from "../investorOverview/types";
import { useHistory } from "react-router-dom";
import { DialogCloseIcon } from "../../assets/SvgIcons";
import { useState } from "react";
import { applicantStatusMasters } from "../../utils/constant";


const colorMap: ColorMap = {
    approved: "success.800",
    "approved by checker": "success.800",
    "approved by payment checker": "success.800",
    rejected: "error.500",
    "rejected by checker": "error.500",
    "rejected by payment checker": "error.500",
    pending: 'warning.500',
}
export default function PaymentsApprovalTableBody({ data }: { data: Array<PaymentApprovalListObj> }): JSX.Element {
    const history = useHistory();
    const [rejectDialogOpen, setRejectDialogOpen] = useState<boolean>(false);
    const [dialogDetails, setDialogDetails] = useState<PaymentApprovalListObj>({} as PaymentApprovalListObj);


    const handlePaymentDetails = (productOrderTableId: string, productType: string, id: string, cartId: string | number, paymentStatus: string) => {
        history.push('/payment-details', {
            productOrderId: productOrderTableId,
            product: productType,
            id,
            cartId,
            paymentStatus
        });
    }
    return (
        <>
            {data?.map((obj: PaymentApprovalListObj) => {

                return (
                    <TableRow
                        key={obj.orderNumber}
                        sx={(theme: Theme) => ({
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        })}
                    >
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.orderNumber ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {dayjs(obj?.orderDate ?? "-").format("DD/MM/YYYY")}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.clientName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.clientCode ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {
                                    obj?.investorType ?
                                        applicantStatusMasters?.[obj.investorType] ?? obj.investorType
                                        : "-"
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                    textTransform: "capitalize"
                                })}
                            >
                                {obj?.modeOfHolding ?? "-"}
                            </Typography>
                        </TableCell>

                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.productType ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.portfolioName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.accountType ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.approvalStatus?.toLowerCase()] ? colorMap[obj?.approvalStatus?.toLowerCase()] : theme.palette.text.primary,
                                    cursor: obj?.approvalStatus === 'Pending' ? 'pointer' : 'text',
                                })}
                            >
                                {obj?.approvalStatus ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.paymentStatus?.toLowerCase()] ? colorMap[obj?.paymentStatus?.toLowerCase()] : theme.palette.text.primary,
                                    cursor: 'pointer',
                                })}
                                onClick={() => handlePaymentDetails(obj?.productOrderTableId ?? '', obj?.productType ?? '', obj?.id ?? '', obj?.cartId ?? '', obj?.paymentStatus ?? '')}

                            >
                                {obj?.paymentStatus ?? "-"}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}
